export default __webpack_public_path__ + "static/media/22.26d8f00c.jpg";